import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { IconService } from '@shared/domain/icon.service';

export const iconInitializerProvider: EnvironmentProviders = provideAppInitializer(() => {
  inject(IconService);
  return Promise.resolve(true);
});
